interface IThrottleOptions {
  leading?: boolean;
  trailing?: boolean;
}

type ThrottledFunction = (...args: any[]) => any;

export default class ThrottleHelper {
  throttle(
    func: Function,
    fnArgs: any[],
    wait: number,
    options?: IThrottleOptions
  ): ThrottledFunction {
    let context: any, args: any, result: any;
    let timeout: NodeJS.Timeout | null = null;
    let previous = 0;

    const later = () => {
      previous = options?.leading === false ? 0 : Date.now();
      timeout = null;
      result = func.apply(context, args);
      if (!timeout) {
        context = args = null;
      }
    };

    return (): any => {
      const now = Date.now();
      if (!previous && options?.leading === false) {
        previous = now;
      }
      const remaining = wait - (now - previous);

      context = this;
      args = fnArgs;

      if (remaining <= 0 || remaining > wait) {
        if (timeout) {
          clearTimeout(timeout);
          timeout = null;
        }
        previous = now;
        result = func.apply(context, args);
        if (!timeout) {
          context = args = null;
        }
      } else if (!timeout && options?.trailing !== false) {
        timeout = setTimeout(later, remaining);
      }

      return result;
    };
  }
}
